/*
As a user of Love Big, I want to be able to update my account information when necessary,
so I can ensure there aren't any discrepancies.
*/

//Packages
import React, { useState, useContext } from "react";
import axios from "axios";
//Material UI Components
import { Grid, Button, TextField, Typography, Box } from "@mui/material";
//API Route
import { Route } from "../../utils/config";
//Context
import { userContext } from "../../Context";

export default function ResetPassword() {
  //User Context
  const { user, setUser } = useContext(userContext);

  //User Data state
  const [userData, setUserData] = useState({
    id: user.id,
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    password: "",
    confirmPassword: "",
  });

  //Updates user and userContext based on changes made by user.
  const updateProfile = () => {
    let store = JSON.parse(localStorage.getItem("login"));
    let body = {
      id: user.id,
      email: userData.email,
      firstName: userData.firstName,
      lastName: userData.lastName,
    };

    store.user = {
      ...store.user,
      id: user.id,
      email: userData.email,
      firstName: userData.firstName,
      lastName: userData.lastName,
    };

    axios
      .post(`${Route}/Accounts/UpdateProfile`, JSON.stringify(body), {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${store.token}`,
        },
      })
      .then((res) => {
        localStorage.setItem("login", JSON.stringify(store));
        setUser(store.user);
      })
      .catch((err) => {
        throw err;
      });
  };

  const resetPassword = () => {
    let store = JSON.parse(localStorage.getItem("login"));
    let body = {
      password: userData.password,
      confirmPassword: userData.confirmPassword,
      refreshToken: store.refreshToken,
    };
    axios
      .post(`${Route}/Accounts/ResetPassword`, JSON.stringify(body), {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${store.token}`,
        },
      })
      .then((res) => {
        //Need to display styled on page instead of window alert
        window.alert("password reset");
      })
      .catch((err) => {
        throw err;
      });
  };

  const handleSetUser = (event) => {
    setUserData({ ...userData, [event.target.name]: event.target.value });
  };
  const handleSetPassword = (event) => {
    setUserData({ ...userData, password: event.target.value });
  };
  const handleSetConfirmPassword = (event) => {
    setUserData({ ...userData, confirmPassword: event.target.value });
  };

  return (
    <div>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          resetPassword();
        }}
        mt={2}
      >
        <Grid container item justifyContent="center">
          <Grid
            container
            item
            xs={10}
            md={6}
            justifyContent="center"
            spacing={3}
            mb={4}
          >
            <Grid item xs={12}>
              <Typography variant="h5" color="#052442" mb={2} mt={2}>
                Reset Password
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                variant="outlined"
                value={userData.password}
                label="Password"
                type="password"
                fullWidth
                onChange={handleSetPassword}
              ></TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                variant="outlined"
                value={userData.confirmPassword}
                label="Confirm Password"
                type="password"
                fullWidth
                onChange={handleSetConfirmPassword}
              ></TextField>
            </Grid>

            <Grid
              container
              item
              justifyContent="space-between"
              alignItems="center"
            >
              <Button type="submit" variant="contained" sx={{ width: 85 }}>
                Reset
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          updateProfile();
        }}
      >
        <Grid container item justifyContent="center">
          <Grid
            container
            item
            xs={10}
            md={6}
            justifyContent="center"
            spacing={3}
            mb={2}
          >
            <Grid item xs={12}>
              <Typography variant="h5" color="#052442" mb={2} mt={2}>
                Account Information
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                fullWidth
                label="First Name"
                name="firstName"
                value={userData.firstName}
                onChange={handleSetUser}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Last Name"
                name="lastName"
                value={userData.lastName}
                onChange={handleSetUser}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Email"
                name="email"
                value={userData.email}
                onChange={handleSetUser}
              />
            </Grid>
            <Grid
              container
              item
              justifyContent="space-between"
              alignItems="center"
            >
              <Button type="submit" variant="contained" sx={{ width: 85 }}>
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
